<ul class="nav nav-tabs">
    @for (tab of tabs; track tab; let i = $index) {
        <li
            [ngClass]="{ active: selectedTabIndex === i }"
            (click)="selectTab(i)">
            <a>{{ tab.title }}</a>
        </li>
    }
</ul>
<div class="tab-content">
    <ng-content select="nlr-tab"></ng-content>
</div>
